import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { forwardRef } from "react";

import { cn } from "@/lib/utils";

interface Props
  extends React.ComponentPropsWithoutRef<
    typeof DropdownMenuPrimitive.RadioItem
  > {
  indicatorColor?: string;
  isIndicatorVisible?: boolean;
}

const DropdownMenuRadioItemWithStatus = forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.RadioItem>,
  Props
>(
  (
    {
      className,
      children,
      indicatorColor = "#6B7280",
      isIndicatorVisible = true,
      ...props
    },
    ref
  ) => (
    <DropdownMenuPrimitive.RadioItem
      ref={ref}
      className={cn(
        "relative flex cursor-default select-none items-center gap-3 rounded-sm py-1.5 pr-5 pl-10 text-sm outline-none transition-colors",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        "hover:rounded-[var(--rounded,4px)] hover:bg-[var(--Zinc-100,#F4F4F5)]",
        isIndicatorVisible ? "pl-10" : "pl-5",
        className
      )}
      {...props}
      onSelect={event => {
        event.preventDefault();
        props.onSelect?.(event);
      }}
    >
      {isIndicatorVisible && (
        <div
          className="absolute left-1.5 h-[7px] w-[7px] rounded-full"
          style={{ backgroundColor: indicatorColor }}
        />
      )}

      <div
        className={cn(
          "absolute left-6 flex h-4 w-4 items-center justify-center rounded-full border border-black",
          !isIndicatorVisible && "left-2"
        )}
      >
        <DropdownMenuPrimitive.ItemIndicator>
          <div className="h-2.5 w-2.5 rounded-full bg-black" />
        </DropdownMenuPrimitive.ItemIndicator>
      </div>

      <span className="ml-3">{children}</span>
    </DropdownMenuPrimitive.RadioItem>
  )
);

DropdownMenuRadioItemWithStatus.displayName = "DropdownMenuRadioItemWithStatus";

export default DropdownMenuRadioItemWithStatus;
